class Loader {
  constructor(selector, options = {}) {
    const DEFAULT_OPTIONS = {
      showOnLoad: false,
    };

    this.options = Object.assign({}, DEFAULT_OPTIONS, options);

    this.element = document.querySelector(selector);

    this.element.style.display = "block";

    if (this.options.showOnLoad) {
      window.addEventListener("load", () => this.show());
    }
  }

  show() {
    this.element.style.display = "block";
  }

  hide() {
    this.element.style.display = "none";
  }
}

export default Loader;
